import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { getUnderground } from '../../utils';
import { SpecialGeo } from '../SpecialGeo';
import { UndergroundIconContainer } from '../UndergroundIconContainer';
import styles from './UndergroundContainer.css';
import { NBSP } from 'shared/constants/symbols';

import type { IOffer } from 'shared/offer';

interface IUndergroundContainerProps {
  offer: IOffer;
}

export const UndergroundContainer: React.FC<IUndergroundContainerProps> = ({ offer }) => {
  const underground = React.useMemo(() => getUnderground(offer), [offer]);

  const remoteness = React.useMemo(() => {
    if (underground && underground.time && underground.time > 0) {
      const Icon = underground.transportType === 'walk' ? IconMapWalk16 : IconMapCar16;
      const displayTime = `${underground.time}${NBSP}мин`;

      return (
        <span className={styles['remoteness']}>
          <Icon />
          {displayTime}
        </span>
      );
    }

    return null;
  }, [underground]);

  if (!underground) {
    return null;
  }

  return (
    <SpecialGeo
      label={underground.name}
      icon={<UndergroundIconContainer offer={offer} underground={underground} />}
      remoteness={remoteness}
    />
  );
};
